import React from 'react';
import classNames from 'classnames';
import {ReactComponent as RelevanceIcon} from 'images/icon/relevance.svg';
import CallActions from 'actions/CallActions';
import './CallSortControl.styl';
import {CalendarDaysIcon} from '@components/icon/CalendarDaysIcon';

export default class CallSortControl extends React.PureComponent {
  toggleSortByDate(sortByDate) {
    CallActions.toggleSortByDate(sortByDate);
    this.props.refreshCurrentSearch();
  }
  render() {
    return (
      <div className="call-sort-control">
        <div className="label">Sort by:</div>
        <div className="control">
          <div
            onClick={() => this.toggleSortByDate(true)}
            className={classNames('button', {toggled: this.props.sortByDate})}>
            <div className="icon-wrapper">
              <CalendarDaysIcon />
            </div>
            Date
          </div>
          <div
            onClick={() => this.toggleSortByDate(false)}
            className={classNames('button', {
              toggled: !this.props.sortByDate,
            })}>
            <div className="icon-wrapper">
              <RelevanceIcon className={'icon'} />
            </div>
            Relevance
          </div>
        </div>
      </div>
    );
  }
}
